import TransformComponent from '../../../../Component/Transform';
import CardComponent from '../../../../Component/Level/Card';
import Renderable from '../../../../Component/Renderable';
import CardStateHelper from '../../../../State/Card/CardStateHelper';
import CardSystem from '../../CardSystem';
import CardModifier from 'Prototype/Level/Card/Modifier/CardModifier';
import CardModifierComponent from 'Component/Level/CardModifier';
import { CardState } from 'Prototype/Level/Card/CardState';
import { IGameState } from 'State/Game/IGameState';

export default class BaseCardModifierHandler {
    public modifier: CardModifier;
    public modifierComponent: CardModifierComponent;
    public transform: TransformComponent;
    public cardComponent: CardComponent;
    public renderable: Renderable;

    constructor(modifier: CardModifier) {
        this.modifier = modifier;

        // Modifiers and their children should not be interactable as the sprites may overlap other cards.
        this.modifier.container.interactive = false;
        this.modifier.container.interactiveChildren = false;
        this.modifier.container.buttonMode = false;

        this.modifierComponent = this.modifier.getComponent(CardModifierComponent);
        this.transform = this.modifier.getComponent(TransformComponent);
        this.cardComponent = this.modifier.getComponent(CardComponent);
        this.renderable = this.modifier.getComponent(Renderable);
    }

    public handleStateChange(state: IGameState, cardSystem: CardSystem) {
        if (
            !this.modifierComponent ||
            !this.modifierComponent.gameObject ||
            this.modifierComponent.gameObject.destroyed
        )
            return;

        switch (CardStateHelper.getCardState(state, this.modifierComponent.cardID)) {
            case CardState.IN_PLAY:
                this.handleModifierInPlay(state, cardSystem);
                break;
            case CardState.IN_STACK:
                this.handleModifierInStack(state, cardSystem);
                break;
            case CardState.FOLDED:
                this.handleModifierFolded(state, cardSystem);
                break;
            case CardState.DISCARDED:
                this.handleModifierDiscarded(state, cardSystem);
                break;
            case CardState.UNKNOWN:
                this.handleModifierUnknown(state, cardSystem);
                break;
        }

        this.modifierComponent.properties = this.getModifierStateData(state).properties;
    }

    protected handleModifierInPlay(state: IGameState, cardSystem: CardSystem) {}
    protected handleModifierInStack(state: IGameState, cardSystem: CardSystem) {}
    protected handleModifierFolded(state: IGameState, cardSystem: CardSystem) {}
    protected handleModifierDiscarded(state: IGameState, cardSystem: CardSystem) {}
    protected handleModifierUnknown(state: IGameState, cardSystem: CardSystem) {}

    public setModifierFaceUp(faceUp: boolean) {
        this.updateVisibility(faceUp);
    }

    protected updateVisibility(visible: boolean): void {
        this.renderable.visible = visible;
    }

    protected getModifierStateData(state: IGameState) {
        const card = state.levelState.cardsState.cards[this.modifierComponent.cardID];
        return card.modifiers.find(data => data.type === this.modifierComponent.type);
    }

    public clearModifier(): void {
        this.modifier.destroy();
    }
}
